import React, {FC, PropsWithChildren} from 'react';

import {LinkNavigationProvider} from '../common/links/linkNavigationProvider';
import {LinkTrackingProvider} from '../common/linkTrap/linkTrackingProvider';

// Providers for modules from the libs/shared packages.
export const SharedProviders: FC<PropsWithChildren<unknown>> = ({children}) => (
  <LinkTrackingProvider>
    <LinkNavigationProvider>{children}</LinkNavigationProvider>
  </LinkTrackingProvider>
);
